import { find } from "lodash";
import { t } from "@/i18n-js/instance";
import { TextSelect } from "@circle-react-shared/TextSelect";
import { EmptyState } from "@circle-react-shared/uikit/EmptyState";
import { useChangesConfirmationModal } from "./ChangesConfirmationModal";
import { useAccessGroupSourcesData } from "./DataStoreContext/AccessGroupSourcesDataContext";
import { Wrapper } from "./Wrapper";
import { ACCESS_GROUPS_KB_ARTICLE_URL } from "./constants";
import { useAccessGroupsActions } from "./hooks/useAccessGroupsActions";

const i18nRoot = "settings.access_groups.admin.entry_points.association";

export const AccessGroupsSelect = () => {
  const {
    selectedAccessGroups,
    appendAccessGroup,
    openNewAccessGroupModal,
    isSyncing,
  } = useAccessGroupsActions();
  const addAccessGroupConfirmationModal = useChangesConfirmationModal();

  const { accessGroups, addConfirmationDetails } = useAccessGroupSourcesData();

  const onSelect = (value: number) => {
    const selectedGroup = find(accessGroups, { id: value });

    if (selectedGroup) {
      if (addConfirmationDetails) {
        void addAccessGroupConfirmationModal.show({
          accessGroup: selectedGroup,
          confirmationDetails: addConfirmationDetails,
          onConfirm: () => {
            appendAccessGroup(selectedGroup);
          },
          modalTitle: t([i18nRoot, "connect"]),
        });
      } else {
        appendAccessGroup(selectedGroup);
      }
    }
  };

  const openKBArticle = () => {
    window.open(ACCESS_GROUPS_KB_ARTICLE_URL, "_blank");
  };

  if (accessGroups.length <= 0) {
    return (
      <Wrapper className="mt-6">
        <EmptyState
          header={t([i18nRoot, "no_groups_empty_state.title"])}
          description={t([i18nRoot, "no_groups_empty_state.description"])}
          primaryLabel={t([i18nRoot, "no_groups_empty_state.primary_cta"])}
          onPrimaryClick={() => openNewAccessGroupModal()}
          secondaryLabel={t(["learn_more"])}
          onSecondaryClick={openKBArticle}
        />
      </Wrapper>
    );
  }

  const accessGroupsSelectedIds =
    (selectedAccessGroups &&
      selectedAccessGroups?.map(accessGroup => accessGroup?.id)) ||
    [];

  const options = accessGroups
    .filter(accessGroup => !accessGroupsSelectedIds.includes(accessGroup.id))
    .map(accessGroup => ({
      value: accessGroup.id,
      label: accessGroup.name,
    }));

  return (
    <TextSelect
      placeholder={t([i18nRoot, "select_placeholders.select"])}
      emptyMessage={t([i18nRoot, "select_placeholders.no_groups"])}
      options={options}
      onChange={onSelect}
      value={0}
      disabled={isSyncing}
      createLinkLabel={t([i18nRoot, "actions.create_new_access_group"])}
      onCreateLinkClick={openNewAccessGroupModal}
    />
  );
};
